'use strict';

/**
 *  Mobile nav // Off Canvas
 */
(function () {
  var hamburger = document.getElementById('hamburger');
  var navigation = document.querySelector('nav.navigation');
  var announcement = document.querySelector('.header-announcement');
  var logoY = document.querySelector('.banner__logo').offsetHeight / 2;
  var headerMain = document.getElementById('header-main');

  var fixOffset = function fixOffset() {
    if (announcement) {
      var offset = headerMain.offsetHeight;
      document.body.setAttribute('style', 'padding-top:' + offset + 'px;margin-top:-' + offset + 'px;');
    }
  };

  var animateOpacity = function animateOpacity(type, el, opacity) {
    if (type === 'in') {
      el.style.opacity = opacity / 100;
      opacity++;
      return opacity;
    } else {
      el.style.opacity = opacity / 100;
      opacity--;
      return opacity;
    }
  };

  var fireOverlay = function fireOverlay() {
    if (navigation.classList.contains('active')) {
      var overlay = document.createElement('div');
      var fadeIn = void 0;
      var opacity = 0;

      overlay.classList.add('bg-overlay');
      headerMain.insertBefore(overlay, navigation);
      fadeIn = setInterval(function () {
        if (opacity <= 100) {
          opacity = animateOpacity('in', overlay, opacity);
        } else {
          clearInterval(fadeIn);
        }
      }, 8);
    } else {
      var _overlay = document.querySelector('.bg-overlay');
      var fadeOut = void 0;
      var _opacity = 100;

      fadeOut = setInterval(function () {
        if (_opacity > 0) {
          _opacity = animateOpacity('out', _overlay, _opacity);
        } else {
          clearInterval(fadeOut);
          headerMain.removeChild(_overlay);
        }
      }, 8);
    }
  };

  var destroyOverlay = function destroyOverlay() {
    var overlay = document.querySelector('.bg-overlay');
    headerMain.removeChild(overlay);
  };

  var closeNav = function closeNav() {
    hamburger.classList.remove('active');
    navigation.classList.remove('active');
    document.body.classList.remove('nav-active');
  };

  var attachNav = function attachNav() {
    var winScrollPoint = window.pageYOffset;
    var scrollPoint = void 0;
    if (announcement) {
      scrollPoint = announcement.offsetHeight;
    } else {
      scrollPoint = 0;
    }
    if (winScrollPoint > scrollPoint) {
      headerMain.classList.add('fixed');
      document.body.classList.add('scrolled');
    } else {
      headerMain.classList.remove('fixed');
      document.body.removeAttribute('style');
      document.body.classList.remove('scrolled');
    }
  };

  /** The following block is subject to code review.
   *  Preferred method would be to refactor template code
   *  This is intended to be temporary for proof of concept.
   */

  var moveActions = function moveActions() {
    var actions = document.querySelector('.banner__actions');
    var banner = document.querySelector('.banner__logo');
    var bannerWrapper = banner.parentElement;
    var offCanvas = document.querySelector('.banner__navigation');
    var navLIst = document.querySelector('.navigation__list');
    if (window.outerWidth < 768) {
      offCanvas.insertBefore(actions, navLIst);
    } else if (!actions.parentElement.classList.contains('row')) {
      bannerWrapper.insertBefore(actions, banner);
    }
  };

  // Attach event listeners
  hamburger.addEventListener('click', function () {
    hamburger.classList.toggle('active');
    navigation.classList.toggle('active');
    document.body.classList.toggle('nav-active');
    fireOverlay();
  });

  window.addEventListener('resize', function () {
    moveActions();
    fixOffset();
    if (window.outerWidth > 768) {
      if (document.querySelector('.bg-overlay') != null) {
        destroyOverlay();
      }
      closeNav();
    }
  });

  window.addEventListener('scroll', function () {
    attachNav();
  });
  window.addEventListener('DOMContentLoaded', function () {
    moveActions();
    fixOffset();
    attachNav();
  });
})();